var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetailerMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#6F3289"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9736 9.5868C13.8989 9.59637 13.8223 9.60212 13.7419 9.60212C13.243 9.60212 12.7995 9.3842 12.4935 9.04736C12.1908 9.38381 11.7465 9.60212 11.2467 9.60212C10.7479 9.60212 10.3034 9.3842 9.99896 9.04736C9.69372 9.38381 9.25137 9.60212 8.74966 9.60212C8.25063 9.60212 7.80637 9.3842 7.5019 9.04736C7.19858 9.38381 6.75431 9.60212 6.25375 9.60212C6.17607 9.60212 6.09769 9.59666 6.02166 9.58671C4.96233 9.44509 4.46108 8.19656 5.02763 7.30038L6.12526 5.56393C6.22302 5.40786 6.39737 5.3125 6.5835 5.3125H13.4159C13.602 5.3125 13.7763 5.40782 13.8742 5.56393L14.9718 7.30038C15.54 8.19848 15.0364 9.44509 13.9736 9.5868Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.2895 9.5025L14.2914 14.1979C14.2914 14.7055 13.8799 15.1171 13.3894 15.1171H6.62977C6.12212 15.1171 5.72784 14.7055 5.72784 14.1979L5.71118 9.5025C5.80967 9.54024 5.91014 9.57153 6.02159 9.58653C6.09761 9.59633 6.17593 9.60208 6.25368 9.60208C6.49764 9.60208 6.72705 9.54871 6.93443 9.45666V12.666H13.0639V9.45654C13.2707 9.54846 13.5005 9.60208 13.7418 9.60208C13.8211 9.60208 13.8971 9.59684 13.9733 9.58689C14.0884 9.57144 14.1899 9.5408 14.2895 9.5025Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 24,
    r: 2,
    fill: "#6F3289"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailerMarker);
export default __webpack_public_path__ + "static/media/retailer-marker.789b1803cfded10f472676290062526d.svg";
export { ForwardRef as ReactComponent };